import { ThrowLiteError } from '../lite-error.js';

async function parseGltfJsonAsset(buffer, baseUrl) {
  const json = JSON.parse(new TextDecoder().decode(buffer));
  const buffers = json.buffers ?? [];
  let binChunk;
  if (buffers.length > 1) {
    const multiBuffer = await import('./gltf-multi-buffer.js');
    binChunk = await multiBuffer.loadMultiBuffer(json, baseUrl);
  } else if (buffers[0]?.uri) {
    binChunk = new DataView(await fetch(resolveBufferUri(buffers[0].uri, baseUrl)).then((r) => r.arrayBuffer()));
  } else {
    binChunk = new DataView(new ArrayBuffer(0));
  }
  return { json, binChunk, baseUrl };
}
async function resolveExternalImage(uri, baseUrl) {
  const response = await fetch(resolveBufferUri(uri, baseUrl));
  if (!response.ok) {
    ThrowLiteError(136, response.status, response.statusText);
  }
  return createImageBitmap(await response.blob(), { premultiplyAlpha: "none", colorSpaceConversion: "none" });
}
function resolveBufferUri(uri, baseUrl) {
  if (baseUrl) {
    return new URL(uri, baseUrl + "x").href;
  }
  try {
    return new URL(uri) + "";
  } catch {
    ThrowLiteError(137);
  }
}

export { parseGltfJsonAsset, resolveBufferUri, resolveExternalImage };
//# sourceMappingURL=gltf-json-asset.js.map
